// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import UserBadgeSvg from '@rsuite/icon-font/lib/people/UserBadge';
var UserBadge = createSvgIcon({
  as: UserBadgeSvg,
  ariaLabel: 'user badge',
  category: 'people',
  displayName: 'UserBadge'
});
export default UserBadge;